export const jobValues: string[] = [
  'roofer',
  'roofer_master',
  'carpenter',
  'carpenter_master',
  'building_engineer',
];
